// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, Flex, Space, Sx } from '@mantine/core';
import { FC, useContext } from 'react';
// eslint-disable-next-line import/no-unresolved
import { A11y, Navigation, Pagination } from 'swiper/modules';
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
import { DataS } from '../../../Service/DataS';
import { WindowContext } from '../../../Service/Context/WindowContext';
import { BillingInterval } from '../../../Types/Billing';
import Plan from './Plan';

const mobileCardSwiperSx: Sx = (theme) => ({
  marginLeft: -4,
  marginRight: -4,
  '.swiper': {
    paddingLeft: 4,
    paddingRight: 4,
    paddingBottom: 30,
    overflow: 'visible',
  },
  '.swiper-wrapper': {
    alignItems: 'stretch',
  },
  '.swiper-slide': {
    height: 'auto',
    display: 'flex',
  },
  '.swiper-slide > .mantine-Indicator-root': {
    width: '100%',
    maxWidth: '100%',
  },
  '.swiper-pagination': {
    bottom: 0,
  },
  '.swiper-button-prev, .swiper-button-next': {
    width: 32,
    height: 32,
    marginTop: -28,
    borderRadius: 32,
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.white,
    boxShadow: theme.colorScheme === 'dark' ? '0 5px 16px rgba(0, 0, 0, 0.3)' : '0 5px 16px rgba(29, 81, 145, 0.16)',
    color: '#FE8047',
    '&::after': {
      fontSize: 13,
      fontWeight: 900,
    },
  },
  '.swiper-button-prev': {
    left: 0,
  },
  '.swiper-button-next': {
    right: 0,
  },
  '.swiper-button-disabled': {
    opacity: 0.28,
  },
  '.swiper-pagination-bullet': {
    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.gray[5] : theme.colors.gray[4],
    opacity: 1,
  },
  '.swiper-pagination-bullet-active': {
    backgroundColor: '#FE8047',
  },
});

const AvailablePlans: FC<{ billingInterval: BillingInterval }> = ({ billingInterval }) => {
  const { sm } = useContext(WindowContext);
  const plans = DataS.billingPlans;

  return (
    <div>
      {sm ? (
        <Box sx={mobileCardSwiperSx}>
          <Swiper
            modules={[Navigation, Pagination, A11y]}
            navigation
            pagination={{ clickable: true, dynamicBullets: plans.length > 4 }}
            slidesPerView={1.08}
            spaceBetween={16}
            centeredSlides
            grabCursor
          >
            {plans.map((plan) => (
              <SwiperSlide key={plan.name}>
                <Plan billingPlan={plan} billingInterval={billingInterval} />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      ) : (
        <Flex gap="md" wrap="wrap" justify="center" align="stretch">
          {plans.map((plan) => (
            <Plan key={plan.name} billingPlan={plan} billingInterval={billingInterval} />
          ))}
        </Flex>
      )}
      <Space h="md" />
    </div>
  );
};

export default AvailablePlans;
